import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    Draft: 'bg-gray-100 text-gray-800',
    Submitted: 'bg-blue-100 text-blue-800',
    Approved: 'bg-indigo-100 text-indigo-800',
    Provisioning: 'bg-yellow-100 text-yellow-800',
    Provisioned: 'bg-green-100 text-green-800',
    Failed: 'bg-red-100 text-red-800',
    Completed: 'bg-emerald-100 text-emerald-800',
    Rejected: 'bg-rose-100 text-rose-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}
